const obj = {
  user_status: {
    owner: "OW",
    sub_owner: "SOW",
    super_admin: "SUA",
    admin: "AD",
    sub_admin: "SAD",
    senior_super: "SSM",
    super_agent: "SA",
    agent: "AG",
    user: "CL",
  },
  user_next_status: {
    owner: "sub_owner",
    sub_owner: "super_admin",
    super_admin: "admin",
    admin: "sub_admin",
    sub_admin: "senior_super",
    senior_super: "super_agent",
    super_agent: "agent",
    agent: "user",
  },
  market_category: {
    1: "Market",
    3: "Bookmakers",
    5: "ManualOdds",
    10: "Win Toss",
    2: "Session",
    6: "Over by Over Session Market",
    7: "Player",
    9: "Wicket",
    11: "Bowler Session",
    8: "Last Digit ODD",
    4: "LineMarket",
    14: "Premium ODDs",
  },
  betCheckObj: {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  },
};

export default obj;

export const priceData = [
  {
    id: 1,
    value: 10,
  },
  {
    id: 2,
    value: 50,
  },
  {
    id: 3,
    value: 100,
  },
  {
    id: 4,
    value: 200,
  },
  {
    id: 5,
    value: 1000,
  },
  {
    id: 6,
    value: 5000,
  },
];
export const headerData = [
  {
    className: "text-start",
    title: "Market",
    widht: "30%",
  },
  {
    className: "text-end",
    title: "Sports",
    widht: "",
  },
  {
    className: "text-end",
    title: "Selection",
    widht: "",
  },
  {
    className: "text-end",
    title: "Type",
    widht: "",
  },
  {
    className: "text-end",
    title: "Bet ID",
    widht: "",
  },
  {
    className: "text-end",
    title: "Bet placed",
    widht: "",
  },
  {
    className: "text-end",
    title: "Odds req.",
    widht: "",
  },
  {
    className: "text-end",
    title: "Matched",
    widht: "",
  },
  {
    className: "text-end",
    title: "Avg. odds matched",
    widht: "",
  },
  {
    className: "text-end",
    title: "Date matched",
    widht: "",
  },
];

export const validationRules = {
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
  characters: /^[a-zA-Z_ ]*$/,
  numbers: /^[0-9]*$/,
  removeWhitespace: /^[a-zA-Z0-9]+$/,
  // mobile:/^(9|8|7)\d{11}$/,
};
export const AREA_BOUND = {
  UAE: {
    north: 26.245017,
    south: 22.495708,
    east: 56.611014,
    west: 51.498994,
  },
  Saudi: {
    north: 32.1543,
    south: 16.4688,
    east: 55.6667,
    west: 34.5718,
  },
};

export const AREA_REGION = {
  UAE: {
    lat: 23.424076,
    lng: 53.847818,
  },
  Saudi: {
    lat: 23.8859,
    lng: 45.0792,
  },
};

export const COUNTRY_RESTRICTIONS = {
  UAE: "AE",
  Saudi: "SA",
};

export const PROPERTY_ALLOWED_PHOTO_EXT = ["jpeg", "png", "jpg", "gif"];

export const BLOG_TYPES = [
  {
    key: "Website",
    value: "website",
  },
  {
    key: "Customer",
    value: "customer",
  },
  {
    key: "Agent",
    value: "agent",
  },
];

export const QUIZ_TEST_CATEGORIES = [
  {
    _id: "project",
    title: "Project",
  },
  {
    _id: "general",
    title: "General",
  },
  {
    _id: "market_insight",
    title: "Market Insight",
  },
];
